
/** Modifiers **/
export const loadModifiers = (filter) => {
    return axios.get('/chain/api/modifiers', {params: filter}).then(res => res.data);
}
export const modifierLoad = (itemId) => {
    return axios.get(`/chain/api/modifiers/categories/${itemId}`).then((res) => res.data);
};

export const archiveModifier = (itemId) => {
    return axios.post(`/chain/api/modifiers/categories/${itemId}/archive`).then((res) => res.data);
};
export const unarchiveModifier = (itemId) => {
    return axios.post(`/chain/api/modifiers/categories/${itemId}/un-archive`).then((res) => res.data);
};

export const changeModifierPosition = (items) => {
    return axios.post(`/chain/api/modifiers/position`, { items }).then(res => res.data);
}
export const changeModifierItemPosition = (items) => {
    return axios.post(`/chain/api/modifiers/item_position`, {
        items
    }).then(res => res.data);
}

export const addModifierNewCategory = (data) => {
    let formData = new FormData();
    formData.append("name", data.name);
    formData.append("max_amount", data.max_amount);
    formData.append("is_required", Number(data.is_required));
    formData.append("can_items_repeat", Number(data.can_items_repeat));

    return axios.post(`/chain/api/modifiers/categories`, formData, {
        headers: {"Accept": "application/json"},
        onUploadProgress: (e) =>
            console.log(Math.floor((e.loaded * 100) / e.total)),
    })
    .then((res) => res.data);
}

export const editModifierCategory = (data) => {
    let modifierCategoryData = {
        "name": data.name,
        "max_amount": data.max_amount || 0,
        "is_required": data.is_required,
        "can_items_repeat": data.can_items_repeat,
    }
    return axios.put(`/chain/api/modifiers/categories/${data.id}`, {...modifierCategoryData}).then(res => res.data);
}

export const editModifierCategoryName = (data) => {   
    return axios.put(`/chain/api/modifiers/categories/${data.id}`, {"name": data.name}).then(res => res.data);
}

export const addModifierCategory = (name, chain_id) => {
    let formData = new FormData();
    formData.append("name", name);
    if(chain_id) {
        formData.append("chain_id", chain_id);
    }

    return axios.post(`/chain/api/modifiers/categories`, formData, {
        headers: {"Accept": "application/json"},
        onUploadProgress: (e) =>
            console.log(Math.floor((e.loaded * 100) / e.total)),
    })
    .then((res) => res.data);
}

export const modifierNew = (id, data) => {
    let formData = new FormData();
    formData.append("name", data.name);
    formData.append("price", data.price);

    return axios
        .post(`/chain/api/modifiers/categories/${id}/items`, formData, {
            headers: {"Accept": "application/json"},
            onUploadProgress: (e) => console.log(Math.floor((e.loaded * 100) / e.total))})
        .then(res => res.data);
}

export const editModifierItem = (id, data) => {
    let modifierData = {"name": data.name, "price": data.price}
    return axios
        .put(`/chain/api/modifiers/categories/${id}/items/${data.id}`, {...modifierData})
        .then((res) => res.data);
};

export const modifierRemove = (cat_id, id) => {
    return axios
        .delete(`/chain/api/modifiers/categories/${cat_id}/items/${id}`)
        .then((res) => res.data);
};
